// // src/app/modules/Auth/pages/QRCodeView.jsx
// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import QRCode from "react-qr-code";
// import { Download, Share2, CheckCircle, XCircle } from "lucide-react";
// import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
// import "./qrcode.scss";

// export default function QRCodeView() {
//   const { code } = useParams();
//   const [year, setYear] = useState(2024);

//   useEffect(() => {
//     const d = new Date();
//     setYear(d.getFullYear());
//   }, []);

//   // Format code as ABC-DEF (uppercase with hyphen)
//   const formatCode = (code) => {
//     if (!code) return '';
//     const cleanCode = code.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
//     if (cleanCode.length <= 3) return cleanCode;
//     return `${cleanCode.slice(0, 3)}-${cleanCode.slice(3, 6)}`;
//   };

//   const formattedCode = formatCode(code);

//   const downloadQR = () => {
//     const svg = document.getElementById("qr-code-svg");
//     const svgData = new XMLSerializer().serializeToString(svg);
//     const canvas = document.createElement("canvas");
//     const ctx = canvas.getContext("2d");
//     const img = new Image();
    
//     img.onload = () => {
//       canvas.width = img.width;
//       canvas.height = img.height;
//       ctx.drawImage(img, 0, 0);
//       const pngFile = canvas.toDataURL("image/png");
      
//       const downloadLink = document.createElement("a");
//       downloadLink.download = `sety-access-code-${formattedCode}.png`;
//       downloadLink.href = pngFile;
//       downloadLink.click();
//     };
    
//     img.src = "data:image/svg+xml;base64," + btoa(svgData);
//   };

//   const shareQR = async () => {
//     if (navigator.share) {
//       try {
//         await navigator.share({
//           title: "Sety Access Code",
//           text: `My access code: ${formattedCode}`,
//           url: window.location.href,
//         });
//       } catch (err) {
//         console.log("Share cancelled");
//       }
//     } else {
//       navigator.clipboard.writeText(window.location.href);
//       alert("Link copied to clipboard!");
//     }
//   };

//   if (!code) {
//     return (
//       <div className="qr-page">
//         <div className="qr-page-logo">
//           <img
//             src={toAbsoluteUrl("/media/logos/Sety_Logo.svg")}
//             alt="Sety"
//           />
//         </div>
//         <div className="qr-container">
//           <div className="qr-error">
//             <XCircle size={48} />
//             <h2>Invalid Access Code</h2>
//             <p>No access code provided</p>
//           </div>
//         </div>
//         <div className="qr-page-footer">
//           <a href="https://sety.io" target="_blank" rel="noopener noreferrer">
//             Sety
//           </a>
//           <span className="footer-separator">•</span>
//           <span>&copy; {year} All rights reserved</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="qr-page">
//       {/* Logo at top */}
//       <div className="qr-page-logo">
//         <img
//           src={toAbsoluteUrl("/media/logos/Sety_Logo.svg")}
//           alt="Sety"
//         />
//       </div>

//       <div className="qr-container">
//         {/* Header */}
//         <div className="qr-header">
//           <h1 className="qr-title">Security Access Code</h1>
//           <p className="qr-subtitle">Show this QR code at security for access</p>
//         </div>

//         {/* QR Code Display */}
//         <div className="qr-display">
//           <div className="qr-code-wrapper">
//             <QRCode
//               id="qr-code-svg"
//               value={code}
//               size={200}
//               level="H"
//               style={{ height: "auto", maxWidth: "100%", width: "100%" }}
//             />
//           </div>
//         </div>

//         {/* Access Code Text */}
//         <div className="qr-code-text">
//           <div className="qr-code-value">{formattedCode}</div>
//         </div>

//         {/* Action Buttons */}
//         <div className="qr-actions">
//           <button className="qr-btn qr-btn-secondary" onClick={downloadQR}>
//             <Download size={16} />
//             Download
//           </button>
//           <button className="qr-btn qr-btn-secondary" onClick={shareQR}>
//             <Share2 size={16} />
//             Share
//           </button>
//         </div>
//       </div>

//       {/* Footer */}
//       <div className="qr-page-footer">
//         <a href="https://sety.io" target="_blank" rel="noopener noreferrer">
//           Sety
//         </a>
//         <span className="footer-separator">•</span>
//         <span>&copy; {year} All rights reserved</span>
//       </div>
//     </div>
//   );
// }





// src/app/modules/Auth/pages/QRCodeView.jsx
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import QRCode from "react-qr-code";
import { Download, Share2, XCircle } from "lucide-react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import "./qrcode.scss";

export default function QRCodeView() {
  const { code } = useParams();
  const [year, setYear] = useState(2024);

  useEffect(() => {
    const d = new Date();
    setYear(d.getFullYear());
  }, []);

  const formatCode = (code) => {
    if (!code) return '';
    const cleanCode = code.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    if (cleanCode.length <= 3) return cleanCode;
    return `${cleanCode.slice(0, 3)}-${cleanCode.slice(3, 6)}`;
  };

  const formattedCode = formatCode(code);
  const pageUrl = window.location.href;
  const qrImageUrl = `${window.location.origin}/media/logos/Sety-icon-purple.png`;

  const downloadQR = () => {
    const svg = document.getElementById("qr-code-svg");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      
      const downloadLink = document.createElement("a");
      downloadLink.download = `sety-access-code-${formattedCode}.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  const shareQR = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Sety Access Code - ${formattedCode}`,
          text: `My Sety access code: ${formattedCode}`,
          url: pageUrl,
        });
      } catch (err) {
        console.log("Share cancelled");
      }
    } else {
      navigator.clipboard.writeText(pageUrl);
      alert("Link copied to clipboard!");
    }
  };

  if (!code) {
    return (
      <>
        <Helmet>
          <title>Invalid Access Code | Sety</title>
          <meta name="description" content="Invalid or missing Sety access code." />
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        
        <div className="qr-page">
          <div className="qr-page-logo">
            <a href="https://sety.io" target="_blank" rel="noopener noreferrer">
            <img
              src={toAbsoluteUrl("/media/logos/Sety_Logo.svg")}
              alt="Sety"
            />
            </a>
          </div>
          <div className="qr-container">
            <div className="qr-error">
              <XCircle size={48} />
              <h2>Invalid Access Code</h2>
              <p>No access code provided</p>
            </div>
          </div>
          <div className="qr-page-footer">
            <a href="https://sety.io" target="_blank" rel="noopener noreferrer">
              Sety
            </a>
            <span className="footer-separator">•</span>
            <span>&copy; {year} All rights reserved</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Custom Meta Tags for QR Code Page */}
      <Helmet>
        <title>Access Code {formattedCode} | Sety</title>
        <meta name="description" content={`Sety security access code ${formattedCode}. Show this QR code at security checkpoints for seamless entry.`} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content={`Sety Access Code - ${formattedCode}`} />
        <meta property="og:description" content="Secure access code for entry. Show this QR code at security checkpoints." />
        <meta property="og:image" content={qrImageUrl} />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:title" content={`Sety Access Code - ${formattedCode}`} />
        <meta name="twitter:description" content="Secure access code for entry. Show this QR code at security checkpoints." />
        <meta name="twitter:image" content={qrImageUrl} />
        
        {/* Prevent indexing of individual access codes */}
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="qr-page">
        {/* Logo at top */}
        <div className="qr-page-logo">
          {/* <img
            src={toAbsoluteUrl("/media/logos/Sety_Logo.svg")}
            alt="Sety"
          /> */}
           <a href="https://sety.io" target="_blank" rel="noopener noreferrer">
            <img
              src={toAbsoluteUrl("/media/logos/Sety_Logo.svg")}
              alt="Sety"
            />
            </a>
        </div>

        <div className="qr-container">
          {/* Header */}
          <div className="qr-header">
            <h1 className="qr-title">Security Access Code</h1>
            <p className="qr-subtitle">Show this QR code at security for access</p>
          </div>

          {/* QR Code Display */}
          <div className="qr-display">
            <div className="qr-code-wrapper">
              <QRCode
                id="qr-code-svg"
                value={code}
                size={200}
                level="H"
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              />
            </div>
          </div>

          {/* Access Code Text */}
          <div className="qr-code-text">
            <div className="qr-code-value">{formattedCode}</div>
          </div>

          {/* Action Buttons */}
          <div className="qr-actions">
            <button className="qr-btn qr-btn-secondary" onClick={downloadQR}>
              <Download size={16} />
              Download
            </button>
            <button className="qr-btn qr-btn-secondary" onClick={shareQR}>
              <Share2 size={16} />
              Share
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="qr-page-footer">
          <a href="https://sety.io" target="_blank" rel="noopener noreferrer">
            Sety
          </a>
          <span className="footer-separator">•</span>
          <span>&copy; {year} All rights reserved</span>
        </div>
      </div>
    </>
  );
}